import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { VersionService } from './app/shared/services/version.service';

if (environment.production) {
  enableProdMode();
}

// Initialize version service early to handle cache cleanup
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((moduleRef) => {
    // Get the version service and initialize it
    const versionService = moduleRef.injector.get(VersionService);
    if (versionService && typeof versionService.initialize === 'function') {
      versionService.initialize();
    }
  })
  .catch((err) => console.error(err));
